<input [placeholder]="placeholder" [formControl]="control" (blur)="hideDropdown()" (focus)="showDropdown()" class="form-control form-control-dropdown" [id]='idInput'>
<div class="input-dropdown" *ngIf="control.value && valuesDisplay.length > 0 && displayDropdown === true && enabled === true">
  <span (click)="selectTemplate(value)" [title]="value" class="input-dropdown-option" *ngFor="let value of valuesDisplay">
    <span>{{value}}</span>
  </span>
</div>
